import React from 'react'
import { INITIAL_VALUES_ADD_ADMIN, VALIDATION_SCHEMA_ADD_ADMIN } from './utils';
import HOCButton from 'web/components/Button';
import TextInput from 'web/components/form-elements/TextInput';
import { Form, Formik } from 'formik';
import { SelectWrapper } from '../DashBoard/dashBoardStyled';
import Select from 'react-select';

export default function AddAdminModal(props) {
    const options = [
        { label: "All", value: "7" },
        { label: "Dashboard", value: "8" },
        { label: "User Management", value: "5" },
        { label: "User Activity", value: "9" },
        { label: "Reports", value: "6" },
        { label: "Posts", value: "17" },
        { label: "Resolution Center", value: "10" },
        { label: "Subscription", value: "11" },
        { label: "Content Moderatrion", value: "12" },
        { label: "Promo Code", value: "13" },
        { label: "Referral Code", value: "14" },
        { label: "Application Non Users", value: "15" },
        { label: "Language Localization", value: "16" },
        { label: "Location Management", value: "18" },
        { label: "New Invitations", value: "19" },
        { label: "Post Visibility", value: "20" },
        { label: "Retry Orders", value: "21" },
        { label: "Cancel Orders", value: "22" },
        { label: "Quotes", value: "23" },
        { label: "Terms and Conditions", value: "24" },
        { label: "Chat", value: "25" },
        { label: "PT Plus Admin", value: "26" },
        { label: "Order Chat", value: "27" },
    ];
    const submitAdminAcess = data => {
        props.onEnter(data.values)
    }
    return (
        <div>
            <Formik
                initialValues={INITIAL_VALUES_ADD_ADMIN}
                validationSchema={VALIDATION_SCHEMA_ADD_ADMIN}
                onSubmit={(values) => {
                }}>
                {(props) => {
                    const { isValid, dirty, values, setFieldValue } = props;
                    return (
                        <>
                            <Form>
                                <p className="mt-0">Email</p>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ width: '100%' }}>
                                        <TextInput
                                            name='email'
                                            showErrorMessages={true}
                                        />
                                    </div>
                                </div>
                                <p className="mt-0">Select Access</p>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ width: '100%' }}>
                                        <SelectWrapper>
                                            <Select
                                                name='access'
                                                value={values.access}
                                                isMulti
                                                options={options}
                                                onChange={value => {
                                                    if (value !== null) {
                                                        let temp = value.map(data => data.label)
                                                        if (temp.includes('All')) setFieldValue('access', [{ label: "All", value: "7" }])
                                                        else setFieldValue('access', value)
                                                    } else {
                                                        setFieldValue('access', [])
                                                    }
                                                }}
                                            />
                                        </SelectWrapper>
                                    </div>
                                </div>
                                <div style={{ marginTop: '15px', textAlign: '-webkit-center' }}>
                                    <HOCButton
                                        type='app-green-button submitBtn'
                                        handleClick={() => {
                                            submitAdminAcess(props)
                                        }}
                                        disabled={!(isValid && dirty)}>
                                        Add Admin
                                    </HOCButton>
                                </div>
                            </Form>
                        </>
                    );
                }}
            </Formik>
        </div>
    )
}